import {
  SET_CURRENT_LANGUAGE,
  SET_PROJECT_LANGUAGES,
  SET_LOCALE,
} from "actions/ActionTypes";

const initialState = {
  current: {},
  bySlugAndId: {},
};

export default (state = initialState, action) => {
  const { type, currentLanguage, languages, lang } = action;

  switch (type) {
    case SET_PROJECT_LANGUAGES:
      return {
        ...state,
        bySlugAndId: languages,
      };

    case SET_CURRENT_LANGUAGE:
      return {
        ...state,
        current: currentLanguage,
      };

    case SET_LOCALE:
      return {
        ...state,
        current: state.bySlugAndId[lang],
      };

    default:
      return state;
  }
};
